import React from 'react';
import { Modal, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

const LogoutModal = ({ showModal, closeModal, handleLogout }) => {
    return (
        <Modal
            open={showModal}
            onCancel={closeModal}
            footer={null}
            centered
            className="p-0 rounded-lg"
            styles={{
                body: { padding: 0 },
                mask: { backdropFilter: 'blur(4px)' },
            }}
        >
            <div className="flex flex-col items-center justify-center p-8">
                <LogoutOutlined className="text-4xl mb-4" />
                <h1 className="text-xl font-semibold mb-6 text-center">
                    Are you sure you want to logout?
                </h1>
                <div className="flex gap-4">
                    <Button
                        type="default"
                        onClick={closeModal}
                        className="px-6 rounded-md text-base font-medium"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleLogout}
                        className="px-6 rounded-md text-base font-medium"
                    >
                        Logout
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default LogoutModal;